/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{getStaticNodeConfig as e}from"lexical";function n(n){const t=new Set,c=new Set;for(const f of o(n)){const n="function"==typeof f?f:f.replace;e(n),t.add(n.getType()),c.add(n)}return{nodes:c,types:t}}function o(e){return("function"==typeof e.nodes?e.nodes():e.nodes)||[]}export{n as getKnownTypesAndNodes,o as getNodeConfig};
